/**
 * Calcula el percent_change real considerando cambios de moneda.
 * Si la moneda del precio anterior difiere de la actual, normaliza usando dólar blue.
 */
export function calcNormalizedChange(item, cotizacion) {
  const history = item.price_history;
  if (!history || history.length < 2) return item.percent_change || 0;

  const current = history[history.length - 1];
  const previous = history[history.length - 2];

  // Si misma moneda, usar percent_change original
  if (current.currency === previous.currency) return item.percent_change || 0;

  // Hay cambio de moneda — normalizar a la moneda actual
  if (!cotizacion || !cotizacion.venta) return null; // no podemos calcular

  let prevNormalized = previous.price;
  if (current.currency === 'USD' && previous.currency === 'ARS') {
    prevNormalized = previous.price / cotizacion.venta;
  } else if (current.currency === 'ARS' && previous.currency === 'USD') {
    prevNormalized = previous.price * cotizacion.venta;
  }

  if (prevNormalized === 0) return 0;
  return ((current.price - prevNormalized) / prevNormalized) * 100;
}
